module.exports = __webpack_public_path__ + "static/img/SupandSera.a52b94b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SupandSera.png
// module id = vpec
// module chunks = 1